import './StartPvP.css';
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {useActions} from "../../../../hooks/useActions";
import {WsService} from "../../../../services/PvP/WsService";
import ServerStateDispatcher from "../../../../services/states/ServerStateDispatcher";
import {MusicService} from "../../../../services/MusicService";
import React, {useLayoutEffect, useState} from "react";
import Helper from "../../../../services/Helper";
import GameService from "../../../../api/GameService";
import {SoundsService} from "../../../../services/SoundsService";
import {sounds} from "../../../../sounds/sound";
import {BattleBg} from "../../../../services/BattleBg";
import {config} from "../../../../config";

function StartPvP() {

    const {game, gamePvPData} = useTypedSelector(state => state.game);
    const {user, inQueue, tutorial, isLoading} = useTypedSelector(state => state.auth);
    const {
        processPvPGame,
        setGamePvPData,
        setGame,
        setEndGame,
        setIsPvP,
        setInQueue,
        startGame,
        setSystemMessage,
        setBattleBg,
        setRoute,
        setTutorial,
        setDeck
    } = useActions();

    const [secondsPassed, setSecondsPassed] = useState(0);
    let [timer, setTimer] = useState(null);
    const [waitToPlayCpu, setWaitToPlayCpu] = useState(0);

    const [showPlayButton, setShowPlayButton] = useState(true);

    const activeDeck = user.decks.find((deck) => deck.is_active) ?? user.decks[0];

    if (waitToPlayCpu === 0) {


        setWaitToPlayCpu(Helper.getRandomNumber(config.BOT_TIMER_START, config.BOT_TIMER_END));
        // setWaitToPlayCpu(Helper.getRandomNumber(5, 7));
    }


    const startGameWithBot = async () => {
        SoundsService.playSound(sounds.start_pvp());
        await startGame(21);
        await new Promise(r => setTimeout(r, 100));

        setRoute('game');

        MusicService.stopTutorial();
        MusicService.stopMenu();
        MusicService.playBattleMusic();
    }

    const canselQueue = () => {
        WsService.inQueue = false;
        setInQueue(false);
        GameService.cancelQueue();
        setWaitToPlayCpu(0);
        setSecondsPassed(0);
        if (timer !== null) {
            clearInterval(timer);
            setTimer(null);
        }
        setTimeout(() => {

            setShowPlayButton(true);

        }, 3000);

    }

    if (waitToPlayCpu === secondsPassed && waitToPlayCpu !== 0) {
        if (WsService.allowPlayBot) {
            canselQueue();
            startGameWithBot();
        }
    }

    if (WsService.forcePlayBot && waitToPlayCpu < secondsPassed && waitToPlayCpu !== 0) {
        canselQueue();
        startGameWithBot();
    }


    if (inQueue && timer === null) {
        // @ts-ignore
        timer = setInterval(() => {

            setSecondsPassed(sp => sp + 1);

        }, 1000);
        setTimer(timer);
    }


    const minutes = Helper.addLeadingZero(~~(secondsPassed / 60));
    const seconds = Helper.addLeadingZero(secondsPassed % 60);

    if (gamePvPData !== null && game === null) {

        WsService.inQueue = false;

        setTimeout(() => setGamePvPData(null), 0);

        setTimeout(() => setIsPvP(true), 100);
        setTimeout(() => processPvPGame(gamePvPData), 100);

        ServerStateDispatcher.startStackLoop();

        setTimeout(function () {
            SoundsService.playSound(sounds.start_pvp());
            if (timer !== null) {
                clearInterval(timer);
                setTimer(null);
            }
            setSecondsPassed(0);
            setInQueue(false);
            setEndGame({winner: null, result: null});
            MusicService.stopTutorial();
            MusicService.stopMenu();
            MusicService.playBattleMusic()

            setRoute('game');
        }, 500)
    }

    const queue = async () => {
        setIsPvP(false);
        setGamePvPData(null);
        setGame(null);
        WsService.inQueue = true;
        WsService.allowPlayBot = true;
        WsService.forcePlayBot = false;
        await WsService.enterQueue();
    }

    useLayoutEffect(() => () => {
        canselQueue();
    }, [])

    const isDisabled = tutorial.isActive && tutorial.step !== 'ArenaFinish240';

    return <div className={'startPvPContainer'}>
        {showPlayButton ?
            <div
                className={`startPvPButton ${!isDisabled ? 'defaultButtonAnimation' : ''} ${isDisabled ? 'disabled' : ''}`}
                onClick={async () => {
                    if (isDisabled) {
                        return;
                    }

                    if (tutorial.step === 'ArenaFinish240') {
                        tutorial.step = '';
                        tutorial.isActive = false;
                        setTutorial(tutorial);
                        setWaitToPlayCpu(2);
                    }

                    if (user.deck.total_amount < 50) {
                        setSystemMessage({
                            isVisible: true,
                            type: 'info',
                            text: 'The deck must contain at least 50 cards',
                            action: null
                        })
                        return;
                    }
                    setShowPlayButton(false);
                    setBattleBg(BattleBg.choiceBg(null));

                    setInQueue(true);
                    WsService.clearMessages();
                    let res = await WsService.start(true);
                    if (res) {
                        setTimeout(() => {
                            queue();
                        }, 2000);

                    }
                    await WsService.sendingMessageLoop(true);
                }}></div>
            : <div className={'startPvPTimerContainer'}>
                {(timer !== null) ?
                    <div className={'startPvPTimer'}>

                        <div className={'startPvPElement startPvPTimerText'}>
                            <div><span>{minutes}</span>:<span>{seconds}</span></div>
                        </div>
                        <div className={'startPvPElement startPvPTimerTextFind'}>Finding opponent...</div>

                    </div>
                    : <div></div>
                }
            </div>
        }
        {showPlayButton ?
            <div className={'arenaDeckSelectContainer'}>
                <div>Choose your deck:</div>
                <select className='DeckSelectArena' name="DeckSelect"
                        value={activeDeck.id}
                        onChange={(e) => {
                            if (isLoading) {
                                return;
                            }
                            setDeck(Number(e.target.value))
                        }
                        }
                        onMouseDown={(e) => e.stopPropagation()}
                >
                    {user.decks.map((deck) => (
                        <option key={deck.id} value={deck.id}>
                            {deck.name + ' (' + (deck.total_amount ?? 0) + ')'}
                        </option>
                    ))}
                </select>
            </div>
            : <div></div>
        }

    </div>
}

export default StartPvP;